import type { TurnstileInstance } from "@marsidev/react-turnstile";
import type { RefObject } from "react";
import type { RegisterTrialPublicFormValues, TrialLeadFormValues } from "./RegisterTrialPublicForm.schema";
import type { TrialPrefill } from "./trialPrefill";

export type {
  RegisterTrialPublicFormInput,
  RegisterTrialPublicFormValues,
  TrialLeadFormValues,
} from "./RegisterTrialPublicForm.schema";

// Lives here rather than beside the schema so callers narrowing a submit payload do not
// pull zod and the generated gateway enums into their module graph.
export function isTrialLeadFormValues(values: { company: string }): values is TrialLeadFormValues {
  return "country" in values;
}

// The return leg has nothing left to ask: everything else was captured before Trimble ID.
export interface TrialProvisioningFormValues {
  company: string;
  companyRole?: string;
  phone?: string;
  acceptedTerms: true;
}

export interface PublicTrialTurnstileController {
  ref: RefObject<TurnstileInstance | null>;
  token: string | null;
  error: string | null;
  onSuccess: (token: string) => void;
  onExpire: () => void;
  onError: () => void;
  reset: () => void;
}

export type TrialSignupOutcome = { kind: "ineligible"; status: string } | { kind: "failed"; message: string };

export interface RegisterTrialPublicController {
  isSubmitting: boolean;
  submit: (values: RegisterTrialPublicFormValues | TrialProvisioningFormValues) => Promise<void>;
  turnstile: PublicTrialTurnstileController;
  trialSignupOutcome: TrialSignupOutcome | null;
}

export interface RegisterTrialPublicFormProps {
  controller: RegisterTrialPublicController;
  identityPrefill?: TrialPrefill;
  // Provisioning after the Trimble ID hop reuses the outcome screens but has nothing
  // left to ask, so the fields give way to progress.
  hideFields?: boolean;
}
